import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
const PIXEL_ID = '1074520198588474';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const metaWindow = window as Window & {
        fbq?: PixelFunction;
        _fbq?: PixelFunction;
      };
      if (!metaWindow.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as PixelFunction;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        metaWindow.fbq = pixel;
        metaWindow._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      metaWindow.fbq?.('init', PIXEL_ID);
      metaWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="su45bjsmf6ga">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="stkmm0v5ce17" />
      </noscript>
      <main className="min-h-screen w-full overflow-x-hidden bg-brand-cream" data-id="element-2" data-mp="3uc9km0owfule">
        <div className="mx-auto w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="d3mlpfjtr3m9">
          <PurchasePopup data-id="element-4" data-mp="85uivqhn5x3a" />
          <Hero data-id="element-5" data-mp="86mfn4mz60v5" />
          <PainSection data-id="element-6" data-mp="864a1hefaaak" />
          <ModulesSection data-id="element-7" data-mp="83i0xdbvvmq8" />
          <BonusSection data-id="element-8" data-mp="3gl4rlhg1e0k1" />
          <BenefitsSection data-id="element-9" data-mp="3gmfwxlp4rgd9" />
          <PricingCard data-id="element-10" data-mp="3glo067jsrcle" />
          <Guarantee data-id="element-11" data-mp="3gj1vqgs7dd7e" />
          <Testimonials data-id="element-12" data-mp="3bmti57tnls2c" />
          <FAQ data-id="element-13" data-mp="3bnct24kvzg6v" />
          <FinalCTA data-id="element-14" data-mp="3bnuvxk220snr" />
          <Footer data-id="element-15" data-mp="3bkgr855x47d5" />
        </div>
      </main>
    </>;
}